import React from 'react';
import { Table, Button } from '../common';
import { Badge } from '@emorg-prd/standard-react';
import AWSAccountRequest from '../../models/entities/AWSAccountRequest';
import WorkflowStateBadge from '../common/WorkflowStateBadge';
import { useNavigate } from 'react-router-dom';

interface ApprovalsAWSAccountsTableRowProps {
    account: AWSAccountRequest;
}

const ApprovalsAWSAccountsTableRow = ({ account }: ApprovalsAWSAccountsTableRowProps) => {
    const navigate = useNavigate();

    const handleViewDetails = () => {
        navigate(`/awsAccounts/${account.id}`);
    };

    return (
        <Table.Row verticalAlign='middle'>
            <Table.Cell>
                <span >{account.accountName ?? 'N/A'}</span>
            </Table.Cell>
            <Table.Cell className="em-u-text-align-center">
                <Badge
                    text={account.isManaged ? 'Managed' : 'Disconnected'}
                    type={'em-c-badge--positive'}
                />
            </Table.Cell>
            <Table.Cell >
                <WorkflowStateBadge
                    workflowState={account.workflowInstance?.currentWorkflowInstanceState?.workflowState}
                    fullWidth
                />
            </Table.Cell>
            <Table.Cell>
                <Button
                    size='medium'
                    onClick={handleViewDetails} variant="primary">
                    See Details
                </Button>
            </Table.Cell>
        </Table.Row>
    );
};

export default ApprovalsAWSAccountsTableRow;
